import { AssignmentViewModel } from 'chaika-frontend-types/frontend-cms';
import { Nullable } from 'chaika-common-types';

import { OptionType } from '@components/Select';
import type { DurationUpdateParams } from '@components/DurationForm';
import { isDefined } from '@utils/isDefined';

interface Props {
    selectedIds: string[];
    onChange(item: Partial<AssignmentViewModel>): void;
}

interface Data {
    onDateChange(params: DurationUpdateParams): void;
    onItemChange(params: Nullable<OptionType>): void;
}

export function useHandlers({ onChange, selectedIds }: Props): Data {
    function onItemChange(params: Nullable<OptionType>): void {
        if (params?.value && !selectedIds.includes(params?.value?.toString() ?? '')) {
            onChange({
                organizationId: params.value.toString(),
            });
        }
    }

    function onDateChange(params: DurationUpdateParams): void {
        if (isDefined(params.startDate)) {
            onChange({ startDate: params.startDate ? params.startDate.toISOString() : params.startDate });
        }
        if (isDefined(params.endDate)) {
            onChange({ endDate: params.endDate ? params.endDate.toISOString() : params.endDate });
        }
    }

    return {
        onDateChange,
        onItemChange,
    };
}
